import { MobileSingularSpecifications } from "./MobileSingularSpecifications";
import SingularSpecificationsSlider from "./Sliders/SingularSpecificationsSlider";

const SingularSpecificationsSections = () => (
  <>
    <div className="hidden md:block">
      <SingularSpecificationsSlider />
    </div>
    <div className="block md:hidden">
      <MobileSingularSpecifications />
    </div>
  </>
);

export default SingularSpecificationsSections;
